/**
 * Theme-aware illustration: renders <base>.svg in light mode and
 * <base>.dark.svg in dark mode via CSS visibility, so it needs no JS
 * theme read (no flash on load, works outside providers - e.g. the
 * root 404). Dark twins are generated from the light SVGs by swapping
 * the baked warm-paper background for the dark paper tone; see
 * ops/scripts/gen_finder_illustrations.py.
 */
export default function Illo({
  base,
  className = "",
  loading,
}: {
  /** Path without extension, e.g. "/illustrations/finder/entry". */
  base: string;
  className?: string;
  /** "lazy" for scenes below the fold: the browser then fetches only
   *  the twin it shows (a hidden lazy image never nears the viewport),
   *  and only when it is about to scroll in. Leave unset above the fold. */
  loading?: "lazy" | "eager";
}) {
  return (
    <>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`${base}.svg`}
        alt=""
        aria-hidden="true"
        loading={loading}
        className={`dark:hidden ${className}`}
      />
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`${base}.dark.svg`}
        alt=""
        aria-hidden="true"
        loading={loading}
        className={`hidden dark:block ${className}`}
      />
    </>
  );
}
